import { Toggle } from '@giphy/react-giphy-brand'
import React, { useContext } from 'react'
import { useHistory } from 'react-router'
import SearchOptionsContext from 'shared/components/context/search-options'
import { googleAnalyticsEvent, trackPageView } from 'shared/util/analytics'
import styled, { css } from 'styled-components'
import { giphyLightestGrey, giphyWhite } from '@giphy/js-brand'

const GIFS_GRADIENT = `linear-gradient(-135deg, rgb(74, 144, 226) 0%, rgb(148, 56, 255) 100%)`
const STICKERS_GRADIENT = `linear-gradient(-135deg, rgb(0, 231, 149) 0%, rgb(0, 187, 221) 100%)`

const Text = styled.div`
    font-size: 17px;
    text-shadow: rgba(0, 0, 0, 0.2) 1px 1px 1px;
`

const ToggleContainer = styled(Toggle)<{ height: number }>`
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.01em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    flex-shrink: 0;
    ${props =>
        props.height &&
        css`
            height: ${props.height}px;
        `}
`

const getPathname = (term: string, isStickerMode: boolean) => {
    const gifUrl = `${term
        .replace(/stickers|sticker|transparent/gi, '')
        .trim()
        .replace(/\s+/g, '-')}`
    return `/search/${gifUrl}${isStickerMode ? `-stickers` : ``}${document.location.search}`
}
type Props = {
    term: string
    width?: number
    height?: number
}
const SearchTypeToggle = ({ term, width = 206, height = 28 }: Props) => {
    const { setType, type } = useContext(SearchOptionsContext)
    const history = useHistory()
    return (
        <ToggleContainer
            toggle={() => {
                const nextType = type === 'gifs' ? 'stickers' : 'gifs'
                setType(nextType)
                const pathname = getPathname(term, nextType === 'stickers')
                setTimeout(() => {
                    googleAnalyticsEvent({
                        category: `Search Page`,
                        action: `${type} Toggle`,
                        label: term,
                    })
                    trackPageView(pathname)
                }, 50)
                history.replace(pathname, history.location.state)
            }}
            isOn={type === 'gifs'}
            height={height}
            width={width}
            offColor={STICKERS_GRADIENT}
            onColor={GIFS_GRADIENT}
            onElement={<Text>GIFs</Text>}
            offElement={<Text>Stickers</Text>}
            borderRadius={22}
            backgroundColor={`transparent`}
            iconOn={giphyWhite}
            iconOff={giphyLightestGrey}
        />
    )
}

export default SearchTypeToggle
